import ExploreIcon from '@mui/icons-material/Explore';
import { MenuItemLink } from 'react-admin';

export const StartProductTourButton = ({
  startTour,
  'data-testid': dataTestId,
}: {
  startTour: () => void;
  'data-testid': string;
}) => (
  <MenuItemLink
    onClick={(event) => {
      event.preventDefault();
      startTour();
    }}
    data-testid={dataTestId}
    leftIcon={<ExploreIcon sx={{ fill: 'rgba(0, 0, 0, 0.87)' }} />}
    primaryText="resources.bo_common.profile_popup.start_tour"
    to=""
  />
);
